// target blank script
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
    }
}
// 



$('.product-parameters, .product__buy-buttons').each(function() {
  // Find the closest common parent for both elements
  $(this).closest('.parent-class').addClass('addcustom-class-by-jquery');
});




